import { createBlock } from 'factories/block';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { InteractionProps, reverse, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import Carousel_default from 'assets/Carousel_Placeholder.png';
import { colors } from 'styles/variables';
import { flatten } from 'factories/utils';
import { createContinueBtn } from './continueBtn';
import { getSId } from '../utils';
import { createMediaBlock } from './media';

const { lGrey0 } = colors;

export type CarouselInteractionProps = InteractionProps & {
  numberOfSlides: number;
};

export const createSlideBlock = (): Block => {
  return createBlock('Slide', [
    createBlock('Image', [], {
      props: {
        // src: Carousel_default,
        src: undefined,
        fit: 'cover',
      },
    }),
    // createMediaBlock({
    //   src: Carousel_default,
    //   child: 1,
    //   fit: 'cover',
    //   useBackgroundControls: false,
    // }),
    createBlock('Text'),
  ]);
};

export const createCarouselBlock = (count: number): Block => {
  return createBlock('Carousel', [...repeat(createSlideBlock, count)]);
};

export const removeCarouselSlide = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'Carousel') {
    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, undefined];
  }
  return [block, undefined];
};

export const addCarouselSlide = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'Carousel') {
    const slideBlock = createSlideBlock();
    const slideBlockRef = { id: slideBlock.id, type: 'Ref' };
    const [newBlocks] = flatten(slideBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 0, slideBlockRef);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

const contentForColumn = (slideCount: number) => (i: number) => {
  return [() => createBlock('Text', []), () => createCarouselBlock(slideCount)][
    i
  ];
};

export const createCarouselInteractionBlock = (
  props: CarouselInteractionProps
) => {
  const {
    carouselColor = '#fff',
    carouselTextColor = lGrey0,
    lockDown = 0,
    style,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(
        contentForColumn(props.numberOfSlides),
        props.columnCount,
        props.columnsReversed
      ),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        carouselColor,
        carouselTextColor,
        lockDown,
      },
      meta: {
        subType: 'Carousel',
        layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
          props.columnsReversed ? 'Reversed' : ''
        }`,
      },
    }
  );
};

export const interactionConfig = {};
